function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["store", "historyProtocol", "historyMiddlewares", "historyOptions", "routeConfig", "matcherOptions", "getFound"];
import useIsomorphicEffect from '@restart/hooks/useIsomorphicEffect';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import createBaseRouter from './createBaseRouter';
import createFarceStore from './createFarceStore';
import { jsx as _jsx } from "react/jsx-runtime";
export default function createFarceRouter(_ref) {
  var userStore = _ref.store,
    historyProtocol = _ref.historyProtocol,
    historyMiddlewares = _ref.historyMiddlewares,
    historyOptions = _ref.historyOptions,
    routeConfig = _ref.routeConfig,
    matcherOptions = _ref.matcherOptions,
    _ref$getFound = _ref.getFound,
    getFound = _ref$getFound === void 0 ? function (_ref2) {
      var found = _ref2.found;
      return found;
    } : _ref$getFound,
    options = _objectWithoutPropertiesLoose(_ref, _excluded);
  var Router = createBaseRouter(options);
  var store = userStore || createFarceStore({
    historyProtocol: historyProtocol,
    historyMiddlewares: historyMiddlewares,
    historyOptions: historyOptions,
    routeConfig: routeConfig,
    matcherOptions: matcherOptions
  });
  var FarceRouterInstance = /*#__PURE__*/forwardRef(function (props, ref) {
    var _useState = useState(function () {
        var _getFound = getFound(store.getState()),
          match = _getFound.match,
          resolvedMatch = _getFound.resolvedMatch;
        return {
          match: match,
          resolvedMatch: resolvedMatch
        };
      }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];
    useIsomorphicEffect(function () {
      return store.subscribe(function () {
        setState(function (prev) {
          var _getFound2 = getFound(store.getState()),
            match = _getFound2.match,
            resolvedMatch = _getFound2.resolvedMatch;
          if ((prev == null ? void 0 : prev.match) === match && prev.resolvedMatch === resolvedMatch) {
            return prev;
          }
          return {
            match: match,
            resolvedMatch: resolvedMatch
          };
        });
      });
    }, []);
    useImperativeHandle(ref, function () {
      return store;
    }, []);
    return /*#__PURE__*/_jsx(Router, Object.assign({}, props, state, {
      store: store
    }));
  });
  FarceRouterInstance.displayName = 'FarceRouter';
  return FarceRouterInstance;
}